import React, { useEffect, useState } from "react";
import styles from "./VendorPayment.module.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  AntdTab,
  Box,
  ServiseProfileComponent,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Popover, Row, Tabs, Typography } from "antd";
import {
  BsChatLeftTextFill,
  BsFillTelephoneFill,
  BsTelephone,
} from "react-icons/bs";
import { MdEmail, MdLocationOn } from "react-icons/md";
import { IoLocationSharp, IoMailOutline } from "react-icons/io5";
import Modal from "../../../../components/modal/Modal";
import { IoIosShareAlt } from "react-icons/io";
import CalendarComp from "../../Vendors/VendorDetails/Calendar/Calendar";
import personIcon from "../../../../assets/personIcon.png";
import dummy from "../../../../assets/dummy.png";
import { LocIcon } from "../../../../components/icons/Icons";
import { VendorMiddleware } from "../../../../Store/Middlewares/VendorMiddleware";
import { useDispatch } from "react-redux";

const VendorPayment = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [calendarModalOpen, setcalendarModalOpen] = useState(false);
  const [linkModalOpen, setLinkModalOpen] = useState(false);
  const [vendorData, setvendorData] = useState();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const data = state?.data;
  // console.log("state?.data", state?.data);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    let data = {
      vendor_id: state?.data?.vendor?.id,
    };
    dispatch(VendorMiddleware.getVendorDetails(data))
      .then((res) => {
        setvendorData(res);
      })
      .catch(() => {});
  };
  // console.log("vendorData", vendorData);

  const contactDetails = [
    {
      title: "Contact:",
      value: vendorData?.contact_no,
      icon: <BsTelephone className={styles.locIcon} size={24} />,
    },
    {
      title: "Email:",
      value: vendorData?.email,
      icon: <IoMailOutline className={styles.locIcon} size={24} />,
    },
    {
      title: "Address:",
      value: vendorData?.address,
      icon: <LocIcon className={styles.locIcon} size={24} />,
    },
  ];

  return (
    <>
      <ServiseProfileComponent
        image={vendorData?.image ? vendorData?.image : dummy}
      >
        <Col xs={24} className={styles.textCol}>
          <Row className={styles.contentCont}>
            <Col xs={24}>
              <TextComponent
                text={data?.vendor?.name}
                textClass={styles.name}
              />
              <TextComponent
                text={data?.vendor_business_info?.service_category_name}
                textClass={styles.type}
              />
            </Col>
          </Row>
          <>
            {contactDetails.map((contact) => (
              <Row className={styles.locCont}>
                <Col xs={24} md={9} lg={6} xl={4}>
                  <Row className={styles.iconText}>
                    {contact.icon}
                    <TextComponent
                      text={contact.title}
                      textClass={styles.locTextBold}
                    />
                  </Row>
                </Col>
                <Col xs={24} md={14} lg={17} xl={19}>
                  <TextComponent
                    text={contact.value}
                    textClass={styles.locText}
                  />
                </Col>
              </Row>
            ))}
          </>
        </Col>
      </ServiseProfileComponent>
      <Col>
        <Row className={styles.headingRow}>
          <TextComponent textClass={styles.headingText}>Payments</TextComponent>
        </Row>
        <Row gutter={[16, 4]}>
          <Col xs={24} lg={12}>
            <Row className={styles.itemRow}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 16 }}
                md={{ span: 16 }}
                lg={{ span: 12 }}
              >
                <TextComponent textClass={styles.itemCategory}>
                  {data?.category?.name}
                </TextComponent>
                <TextComponent textClass={styles.itemTitle}>
                  {data?.title}
                </TextComponent>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 8 }}
                md={{ span: 8 }}
                lg={{ span: 12 }}
              >
                <TextComponent textClass={styles.amount}>
                  {`$${data?.total_budget}`}
                </TextComponent>
                <TextComponent textClass={styles.status}>
                  {data?.status}
                </TextComponent>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Modal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        closable={true}
        className={styles.modal}
      >
        <Row className={styles.modalCont}>
          <TextComponent text={"Phone Number"} textClass={styles.name} />
          <TextComponent
            text={"+1 (234) 456-4567"}
            textClass={styles.PhoneNum}
          />
          <SubmitButton title="Copy" />
        </Row>
      </Modal>

      <Modal
        isModalOpen={calendarModalOpen}
        setIsModalOpen={setcalendarModalOpen}
        closable={true}
        className={styles.modal}
      >
        <Row className={styles.modalCont}>
          <CalendarComp />
        </Row>
        <Row style={{ alignItems: "center" }}>
          <svg
            className={styles.clockIcon}
            viewBox="0 0 53 53"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M26.4521 0.410199C40.5566 0.436024 52.1518 12.057 52.1647 26.183C52.1776 40.4252 40.5695 52.0548 26.3316 52.0592C12.1195 52.0635 0.476985 40.3908 0.515721 26.1744C0.550154 11.9365 12.1798 0.384375 26.4521 0.410199ZM26.2886 31.3824C28.574 31.4039 30.9671 29.9534 31.1479 27.6679C31.3588 25.0166 33.0546 23.6781 34.6213 22.0898C36.8809 19.7958 39.1793 17.5318 41.4475 15.2464C43.2682 13.4128 43.5178 12.0915 42.2954 10.8304C41.0602 9.55206 39.6484 9.76296 37.8665 11.5362C35.3271 14.0584 32.8006 16.5935 30.2698 19.1286C27.3 22.1028 25.4191 22.1114 22.4751 19.1717C21.511 18.2119 20.5555 17.2435 19.5828 16.2923C18.3303 15.0613 16.9229 14.7471 15.6273 16.0814C14.4179 17.3338 14.7149 18.6896 15.8856 19.8732C17.0907 21.0956 18.283 22.3395 19.5311 23.5188C20.5383 24.47 21.2097 25.4083 21.2958 26.9621C21.4379 29.4713 23.8008 31.3608 26.2886 31.3824Z"
              fill="#EF62BD"
            />
          </svg>
          <TextComponent
            text={"02-00 am to 05-00 am"}
            textClass={styles.type}
          />
        </Row>
      </Modal>

      <Modal
        isModalOpen={linkModalOpen}
        setIsModalOpen={setLinkModalOpen}
        closable={true}
        className={styles.cpyModal}
      >
        <div textClass={styles.cpyCont}>
          <TextComponent text={"Copy Link"} textClass={styles.cpyText} />
        </div>
        <Row className={styles.modalCont2}>
          <Col>
            <TextComponent
              text={"https://bestdayever-web.web.app"}
              textClass={styles.linkText}
            />
          </Col>
          <Col>
            <SubmitButton title="Copy Link" btnClass={styles.copyBtn} />
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default VendorPayment;
